var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.$store.state.moduleSetting.navbarColor === '#fff' ? _vm.logoDark : _vm.logoLight,"width":"30"}})}
var staticRenderFns = []

export { render, staticRenderFns }